<div class="cookies" [ngClass]="{'hide-cookies-section':isAcceptCookies}">
    <div class="cookies__holder">
        <div class="cookies__description" l10nTranslate>
            We use cookies to personalize your experience By continuing to visit this website you agree to our use of cookies
        </div>
        <div class="cookies__buttons-holder">
            <button class="cookies__btn-reject" (click)="acceptCookies(true)" l10nTranslate>GOT IT</button>
            <a class="cookies__read-our" [routerLink]="['/cookie-policy']" l10nTranslate>Read Our Cookie Policy</a>
        </div>
    </div>
</div>